import { Lead } from '../components/LeadListTable'

export interface PoolLead extends Lead {
  // Structured fields for rule evaluation
  creditScoreNum: number
  ltvPercent: number
  leadSource: string
  loanType: string
  incomeK: number
  coBorrower: boolean
  veteranStatus: boolean
  currentRate: number
}

export const ALL_LEADS: PoolLead[] = [
  // Existing leads from MOCK_LEADS (CMP-2024-001)
  {
    id: 'LD-9921',
    name: 'Sarah Jenkins',
    phone: '(555) 123-4567',
    email: 'sarah.j@example.com',
    status: 'New',
    lastContact: 'Never',
    loanAmount: '$450,000',
    creditScore: 745,
    source: 'Web Form',
    creditScoreNum: 745,
    ltvPercent: 75,
    leadSource: 'Web Form',
    loanType: 'Conventional',
    incomeK: 120,
    coBorrower: true,
    veteranStatus: false,
    currentRate: 6.8,
  },
  {
    id: 'LD-9922',
    name: 'Michael Ross',
    phone: '(555) 987-6543',
    email: 'mross@example.com',
    status: 'Contacted',
    lastContact: '2 hours ago',
    loanAmount: '$320,000',
    creditScore: 728,
    source: 'Referral',
    creditScoreNum: 728,
    ltvPercent: 85,
    leadSource: 'Referral',
    loanType: 'FHA',
    incomeK: 85,
    coBorrower: false,
    veteranStatus: true,
    currentRate: 7.1,
  },
  {
    id: 'LD-9923',
    name: 'David Chen',
    phone: '(555) 456-7890',
    email: 'dchen@example.com',
    status: 'Qualified',
    lastContact: 'Yesterday',
    loanAmount: '$580,000',
    creditScore: 780,
    source: 'Organic',
    creditScoreNum: 780,
    ltvPercent: 60,
    leadSource: 'Organic',
    loanType: 'Conventional',
    incomeK: 210,
    coBorrower: true,
    veteranStatus: false,
    currentRate: 5.5,
  },
  // Additional leads for simulation
  {
    id: 'LD-1001',
    name: 'Amanda Smith',
    phone: '(555) 234-5678',
    email: 'asmith@example.com',
    status: 'New',
    lastContact: 'Never',
    loanAmount: '$290,000',
    creditScore: 650,
    source: 'Zillow',
    creditScoreNum: 650,
    ltvPercent: 95,
    leadSource: 'Zillow',
    loanType: 'FHA',
    incomeK: 55,
    coBorrower: false,
    veteranStatus: false,
    currentRate: 7.5,
  },
  {
    id: 'LD-1002',
    name: 'John Doe',
    phone: '(555) 876-5432',
    email: 'jdoe@example.com',
    status: 'New',
    lastContact: 'Never',
    loanAmount: '$410,000',
    creditScore: 710,
    source: 'LendingTree',
    creditScoreNum: 710,
    ltvPercent: 82,
    leadSource: 'LendingTree',
    loanType: 'Conventional',
    incomeK: 95,
    coBorrower: true,
    veteranStatus: true,
    currentRate: 6.9,
  },
  {
    id: 'LD-1003',
    name: 'Maria Garcia',
    phone: '(555) 345-6789',
    email: 'mgarcia@example.com',
    status: 'Attempting',
    lastContact: '1 day ago',
    loanAmount: '$550,000',
    creditScore: 760,
    source: 'Organic',
    creditScoreNum: 760,
    ltvPercent: 70,
    leadSource: 'Organic',
    loanType: 'Conventional',
    incomeK: 150,
    coBorrower: false,
    veteranStatus: false,
    currentRate: 6.2,
  },
  {
    id: 'LD-1004',
    name: 'Robert Johnson',
    phone: '(555) 765-4321',
    email: 'rjohnson@example.com',
    status: 'New',
    lastContact: 'Never',
    loanAmount: '$380,000',
    creditScore: 680,
    source: 'Zillow',
    creditScoreNum: 680,
    ltvPercent: 90,
    leadSource: 'Zillow',
    loanType: 'FHA',
    incomeK: 72,
    coBorrower: true,
    veteranStatus: false,
    currentRate: 7.2,
  },
  {
    id: 'LD-1005',
    name: 'Emily Davis',
    phone: '(555) 456-1234',
    email: 'edavis@example.com',
    status: 'Contacted',
    lastContact: '3 days ago',
    loanAmount: '$620,000',
    creditScore: 790,
    source: 'Referral',
    creditScoreNum: 790,
    ltvPercent: 65,
    leadSource: 'Referral',
    loanType: 'Jumbo',
    incomeK: 250,
    coBorrower: true,
    veteranStatus: false,
    currentRate: 5.8,
  },
  {
    id: 'LD-1006',
    name: 'James Wilson',
    phone: '(555) 654-3210',
    email: 'jwilson@example.com',
    status: 'New',
    lastContact: 'Never',
    loanAmount: '$310,000',
    creditScore: 620,
    source: 'Direct Mail',
    creditScoreNum: 620,
    ltvPercent: 96.5,
    leadSource: 'Direct Mail',
    loanType: 'FHA',
    incomeK: 48,
    coBorrower: false,
    veteranStatus: true,
    currentRate: 6.5,
  },
  {
    id: 'LD-1007',
    name: 'Patricia Brown',
    phone: '(555) 567-8901',
    email: 'pbrown@example.com',
    status: 'Qualified',
    lastContact: 'Today',
    loanAmount: '$440,000',
    creditScore: 715,
    source: 'Web Form',
    creditScoreNum: 715,
    ltvPercent: 78,
    leadSource: 'Web Form',
    loanType: 'Conventional',
    incomeK: 105,
    coBorrower: true,
    veteranStatus: false,
    currentRate: 6.7,
  },
  {
    id: 'LD-1008',
    name: 'Thomas Anderson',
    phone: '(555) 098-7654',
    email: 'tanderson@example.com',
    status: 'New',
    lastContact: 'Never',
    loanAmount: '$395,000',
    creditScore: 695,
    source: 'LendingTree',
    creditScoreNum: 695,
    ltvPercent: 88,
    leadSource: 'LendingTree',
    loanType: 'Conventional',
    incomeK: 82,
    coBorrower: false,
    veteranStatus: true,
    currentRate: 7.0,
  },
  {
    id: 'LD-1009',
    name: 'Jennifer Martinez',
    phone: '(555) 678-9012',
    email: 'jmartinez@example.com',
    status: 'Attempting',
    lastContact: 'Yesterday',
    loanAmount: '$275,000',
    creditScore: 660,
    source: 'Zillow',
    creditScoreNum: 660,
    ltvPercent: 92,
    leadSource: 'Zillow',
    loanType: 'FHA',
    incomeK: 60,
    coBorrower: false,
    veteranStatus: false,
    currentRate: 7.4,
  },
  {
    id: 'LD-1010',
    name: 'Christopher Lee',
    phone: '(555) 210-9876',
    email: 'clee@example.com',
    status: 'New',
    lastContact: 'Never',
    loanAmount: '$510,000',
    creditScore: 755,
    source: 'Organic',
    creditScoreNum: 755,
    ltvPercent: 72,
    leadSource: 'Organic',
    loanType: 'Conventional',
    incomeK: 135,
    coBorrower: true,
    veteranStatus: false,
    currentRate: 6.4,
  },
  {
    id: 'LD-1011',
    name: 'Elizabeth Taylor',
    phone: '(555) 789-0123',
    email: 'etaylor@example.com',
    status: 'Contacted',
    lastContact: '4 hours ago',
    loanAmount: '$340,000',
    creditScore: 705,
    source: 'Web Form',
    creditScoreNum: 705,
    ltvPercent: 80,
    leadSource: 'Web Form',
    loanType: 'Conventional',
    incomeK: 90,
    coBorrower: false,
    veteranStatus: false,
    currentRate: 6.8,
  },
  {
    id: 'LD-1012',
    name: 'Daniel White',
    phone: '(555) 321-6540',
    email: 'dwhite@example.com',
    status: 'New',
    lastContact: 'Never',
    loanAmount: '$460,000',
    creditScore: 730,
    source: 'Referral',
    creditScoreNum: 730,
    ltvPercent: 76,
    leadSource: 'Referral',
    loanType: 'Conventional',
    incomeK: 115,
    coBorrower: true,
    veteranStatus: true,
    currentRate: 6.6,
  },
]
